import { useQuery } from '@tanstack/react-query';
import { getStaffPhotoDownloadUrl } from '@/services/storage/staffPhotos';

export const STAFF_PHOTO_QUERY_KEY = 'staffPhoto';

export function useStaffPhotoUrl(storagePath?: string) {
  return useQuery({
    queryKey: [STAFF_PHOTO_QUERY_KEY, storagePath],
    queryFn: () => getStaffPhotoDownloadUrl(storagePath!),
    enabled: Boolean(storagePath),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
